import {Checkbox, Form} from 'semantic-ui-react';

function FormCheckbox(props) {
  const {input, required, label, children, meta: {touched, error}} = props;
  const id = props.id || input.name;
  const checked = typeof input.value === 'boolean' ? input.value : false;

  return (
    <Form.Field
      {...input}
      id={id}
      label={label || children}
      required={required}
      control={Checkbox}
      checked={checked}
      error={(touched && error != null) ? error : false}
    />
  );
}

export default FormCheckbox;
